enum KeyTabs {
  'resumen' = 'resumen',
  'precio-de-mercado' = 'precio-de-mercado',
  'análisis-niv--placas-y-robo' = 'análisis-niv--placas-y-robo',
  'financiamientos' = 'financiamientos',
  'impuestos-y-multas' = 'impuestos-y-multas',
}

export default KeyTabs;
